import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [toast, setToast] = useState(null);

  const dismiss = useCallback(() => setToast(null), []);

  const showError = useCallback((message) => {
    if (!message) {
      return;
    }
    setToast({ tone: 'error', message });
  }, []);

  const showSuccess = useCallback((message) => {
    if (!message) {
      return;
    }
    setToast({ tone: 'success', message });
  }, []);

  useEffect(() => {
    if (!toast) {
      return undefined;
    }
    const timeoutId = setTimeout(dismiss, 5000);
    return () => clearTimeout(timeoutId);
  }, [toast, dismiss]);

  return (
    <NotificationContext.Provider value={{ showError, showSuccess, dismiss }}>
      {children}
      {toast ? (
        <div
          role="status"
          style={{
            position: 'fixed',
            top: 16,
            right: 16,
            zIndex: 10000,
            maxWidth: 360,
            padding: '12px 16px',
            borderRadius: 8,
            color: '#fff',
            background: toast.tone === 'error' ? '#e14eca' : '#00f2c3',
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
          }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <span style={{ flex: 1, color: toast.tone === 'success' ? '#1d253b' : '#fff' }}>
              {toast.message}
            </span>
            <button
              type="button"
              onClick={dismiss}
              aria-label="Cerrar aviso"
              style={{
                background: 'transparent',
                border: 0,
                color: 'inherit',
                cursor: 'pointer',
                fontSize: 16,
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </div>
        </div>
      ) : null}
    </NotificationContext.Provider>
  );
}

export function useNotify() {
  const context = useContext(NotificationContext);
  if (!context) {
    return {
      showError: (message) => console.error(message),
      showSuccess: (message) => console.info(message),
      dismiss: () => {},
    };
  }
  return context;
}
